
import React, { Component}  from 'react';
import CopyToClipboardButton from 'common/CopyToClipboardButton';
import moment from "moment";


export default class DetailCopyToClientClipboardButton extends Component {

  getText = () => {
    const { order } = this.props;
    const isVladivostok = order.department === 1;
    const isMoscow = order.department === 2;
    let text = '';

    if (order.container_number) {
      text += `Номер контейнера: ${order.container_number}`;
    }
    
    if (order.tractor_unit) {
      text += `\nАвто: ${order.tractor_unit.label}`;

      if (order.tractor_unit.color) {
        text += `\nЦвет: ${order.tractor_unit.color}`;
      }
    }

    if (order.semi_trailer) {
      text += `\nПрицеп: ${order.semi_trailer.label}`;
    }

    if (order.driver) {
      const driver = order.driver;
      text += `\nВодитель: ${driver.full_name}`;

      if (driver.birthday) {
        text += `\nДата рождения: ` + moment(driver.birthday).format('DD.MM.YYYY');
      }

      if (isMoscow) {
        if (order.tractor_unit && order.tractor_unit.work_phone) {
          text += `\nРабочий телефон: ${order.tractor_unit.work_phone}`;
        }
      }

      if (isVladivostok) {
        if (order.driver && order.driver.phone_work) {
          text += `\nРабочий телефон: ${order.driver.phone_work}`;
        }
      }

      if (isVladivostok) {
        if (driver.driver_licence_number) {
          text += `\nВод. Удостоверение: ${driver.driver_licence_number}`;
        }
      }

      if (driver.passport_series && driver.passport_number) {
        text += `\nПаспорт: ${driver.passport_series} / ${driver.passport_number}`;
        if (driver.passport_date) {
          text += ', выдан ' + moment(driver.passport_date).format('DD.MM.YYYY');
        }
        if (driver.passport_text) {
          text += ` ${driver.passport_text}`;
        }
      }

      if (driver.passport_code) {
        text += `\nКод подразделения: ${driver.passport_code}`;
      }

      if (isVladivostok) {
        if (driver.passport_birth_place) {
          text += `\nМесто рождения: ${driver.passport_birth_place}`;
        }

        if (driver.passport_address) {
          text += `\nАдрес прописки: ${driver.passport_address}`;
        }
      }

      if (isMoscow) {
        if (driver.driver_licence_number) {
          text += `\nВод. Удостоверение: ${driver.driver_licence_number}`;
        }

        if (driver.driver_licence_issue_date) {
          text += `\nДата выдачи: ` + moment(driver.driver_licence_issue_date).format('DD.MM.YYYY');
        }
      }
    }

    return text;
  };

  render() {
    return (
      <CopyToClipboardButton
        text={this.getText()}
        label={'Скопировать информацию для клиента'}
        size={'small'}
        variant={'outlined'}
      />
    )
  }
}
